import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ThemeColor } from '../../../types/theme';

@Component({
    selector: 'lui-floating-actions',
    templateUrl: './floating-actions.component.html',
    styleUrls: ['./floating-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FloatingActionsComponent {
  @Input() color!: ThemeColor;
  @Input() floatingPanelOpened!: boolean;
  @Input() scrollTopDisabled!: boolean;
  @Input() scrollOffset = window.innerHeight;
  @Output() scrolled: EventEmitter<void> = new EventEmitter();
}
